import React, { Component } from 'react';
import { PropTypes } from 'prop-types';
import * as messageConstants from '../../../shared/messages';

class EntraIdTenantId extends Component {

  static propTypes = {
    entraIdTenantId: PropTypes.string,
    handleChangeEntraIdTenantId: PropTypes.func,
  }

  render() {
    return (
      <div className="row">
        <div className="col-xs-12 col-sm-8">
          <div className="sba-name-placeholder">
            <label
              className="sba-label-title">{messageConstants.ENTRA_ID_TENANT_ID}</label>
            <input
              id="sbaOidcEntraIdTenantIdInput"
              type="text"
              className="form-control app-name"
              value={this.props.entraIdTenantId}
              onChange={this.props.handleChangeEntraIdTenantId}
            /></div>
        </div>
      </div>
    );
  }
}

export default EntraIdTenantId;
